class scrollHelper{
	constructor() {
		
	}
	to(el, tar, buff) {
		$(el).click(function (e) {
			e.preventDefault();
			var target = typeof tar === 'undefined' ? $(this).attr('href') : tar,
				buffer = typeof buff === 'undefined' ? parseInt($('body').css('margin-top')) : buff,
				scrollDest = parseInt($(target).offset().top - buffer);
			$('html, body').animate({
				scrollTop: scrollDest,
			}, 1000);
		});
	}
	toggleClassOnScroll(){
		const body = document.querySelector('body');
		body.onscroll = function(e){
			const location = e.target.scrollingElement.scrollTop;
			const nav = document.querySelector('nav');
			if( window.innerWidth<600 ){
				if(location > 10){
					nav.classList.remove("top");
				} else{
					nav.classList.add("top");
				}
			} else{
				if(location > 300){
					nav.classList.remove("top");
				} else{
					nav.classList.add("top");
				}
			}
		}
	}
	toTarget(tar){
		// console.log($('nav.navbar').outerHeight())
		buffer = typeof buff === 'undefined' ? parseInt($('nav.navbar').outerHeight()) : buff,
		scrollDest = parseInt($(tar).offset().top - buffer);
		$('html, body').animate({
			scrollTop: scrollDest,
		}, 300);
	}
}
window.app.add('scroll', new scrollHelper());